import { Article, DocsHeader, DocsHeading, Section, Image, SectionHeader, DocsIntro } from "../extra/Components";

import bryt from '../assets/10 alicens/1 bryt-small.jpg';
import bryt_small from '../assets/10 alicens/1 bryt-small.jpg';

import nasta from '../assets/10 alicens/3 nästa steg-small.jpg';

import kallot from '../assets/10 alicens/5 kallot-small.jpg';
import packcert from '../assets/10 alicens/6 packcert-small.jpg'
import alicens from '../assets/10 alicens/7 alicens-small.jpg';

import {
    faUserGraduate,
} from "@fortawesome/free-solid-svg-icons";

const ALicens = ({ setSection, setArticle }) => (
    <Article name="A-license" icon={faUserGraduate} id="alicens" setArticle={setArticle} setSection={setSection}>
        <DocsHeader>
            <DocsHeading note="Updaterad: 2022-07-13">A-licens</DocsHeading>
            <DocsIntro>
                <Image image={alicens} imageSmall={alicens} alt="A-licens" />
                <p>A-licens är ett bevis på att du självständigt kan överleva ett fallskärmshopp. Du kan hoppa på
                    vilken klubb du vill i Sverige utan mer problem än att checka in och få sin utrustning kollad.
                    Din licens är under FAI (Fédération Aéronautique Internationale) det betyder att du får hoppa i
                    nästan alla länder. Värt att veta är vissa länder där a-licens är fler hopp kan vilja att man
                    göra några hopp med deras instruktörer innan man får hoppa fritt.</p>
            </DocsIntro>
        </DocsHeader>
        <Section id="vadgora" name="Vad får man göra">
            <SectionHeader>Vad får man göra</SectionHeader>
            <p>Med A-licens får man hoppa ensam. Hoppa utan en instruktör i planet. Använda
                integralhjälm utan visir. Man får börja logga precisionslandningar för B-cert</p>
        </Section>
        <Section id="nastasteg" name="Nästa steg">
            <SectionHeader>Nästa steg</SectionHeader>
            <p>Det första man bör göra när man har licens är att hoppa på. Göra ett antal hopp själv där man
                bygger sin rutin, sitt självförtroende och sin erfarenhet. När man börjar känna sig trygg
                där så kan man gå vidare mot att hoppa med andra.</p>
            <h3>Vidare kallott-utbildning </h3>
            <Image image={kallot} imageSmall={kallot} alt="Kallotflygning" />
            <p>När man har hoppat ett tag och har tur kan det erbjudas kallotflygningskurser. Dessa
                fokuserar mer på hur man kan flyga sin fallskärm och göra på bästa sätt för att landa mjukt.
                Den första kursen kallas Pilot BAS. Kursen innehåller många bra saker att lära sig.</p>
            <h3>Bas kursen</h3>
            <p>Är en förbundskurs som hålls utav Svenska fallskärmsförbundet centralt en gång om året. Nya
                hoppare från hela landet samlas och diskuterar säkerhet och attityder.</p>

            <h3>Pack cert</h3>
            <Image image={packcert} imageSmall={packcert} alt="Pack cert" />
            <p>Under kursen prioriterar många att lära fokusera på hoppen och köpa packningar. Efter man
                fått a-licens är det en bra idé att ta tag i att lära sig för förr eller senare är man på
                fältet en dag när det inte finns någon som vill packa fallskärmar åt andra eller väljer att
                prioritera elever som inte haft en chans att lära sig än.</p>
            <h3>Hoppa på! </h3>
            <Image image={nasta} imageSmall={nasta} alt="Bryt" />

            <p>Det bästa sättet att växa som fallskärmshoppare är att fortsätta hoppa. Bli vän med folk som
                gick samma kurs och andra man träffar på fältet. Ställ frågor om saker du hör folk prata om.
                Det är nu det roliga börjar. Det är såklart ingen tvång dock.</p>
            <h3>Skaffa egen utrustning</h3>
            <p>Känner man att man vill fortsätta hoppa fallskärm kan man i början fortsätta hyra elevriggar
                (hyran är inkluderad i kursavgiften men efter aff-en kostar det). Ska man bara göra några få
                hopp per år kan det var ekonomiskt att hyra men man kommer få ge förtur till elever med
                elevriggarna. Ska man hoppa lite mer blir det ganska snart mer ekonomiskt att köpa en
                begagnad utrustning. Man kan fråga runt på fältet om var man kan hitta begagnat-annonser och
                vad som passar just dig.</p>
        </Section>

        <Section id="licensnivaer" name="Licensnivåer">
            <SectionHeader>Licensnivåer</SectionHeader>

            <table className="table table-bordered">
                <thead>
                    <tr>
                        <th className="col w-auto">Licens</th>
                        <th scope="col" className="w-auto">Krav</th>
                        <th scope="col" className="w-50">Befogenheter</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th>A</th>
                        <td>
                            <ul>
                                <li>Fullgjord utbildning</li>
                            </ul>
                        </td>
                        <td>
                            <ul>
                                <li>rätt att deltaga i alla grenar vid klubbtävlingar</li>
                                <li>använda integralhjälm utan visir</li>
                                <li>genomgå BAS-utbildning</li>
                                <li>genomgå HL-utbildning efter CI:s godkännande </li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <th>B</th>
                        <td>
                            <ul>
                                <li>100 manuella hopp, 10 FS-hopp, varav hälften med minst 3 personer</li>
                                <li>45 min ackumulerad frifallstid</li>
                                <li>10 landningar inom 15 m</li>
                                <li>fallskärmspackarbehörighet</li>
                            </ul>
                        </td>
                        <td>
                            <ul>
                                <li>hoppa på landningsområde med storlek skolfält </li>
                                <li>deltaga i rekordförsök</li>
                                <li>deltaga i vissa nationella och internationella tävlingar</li>
                                <li>hoppa uppvisning på fält av storlek skolfält </li>
                                <li>utföra vattenhopp enligt</li>
                                <li>utföra mörkerhopp enligt punkt</li>
                                <li>använda mjuk hjälm avsedd för hoppning</li>
                                {/**<li>använda integralhjälm med uppfällbart visir</li> **/}
                                <li>använda valfri typ av skor</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <th>C</th>
                        <td>
                            <ul>
                                <li>200 manuella hopp, varav 50 FS-hopp, varav hälften med minst 3 personer
                                </li>
                                <li>1,5 tim ackumulerad frifallstid</li>
                                <li>50 landningar inom 15 m varav 25 landningar inom 5 m</li>
                                <li>1 år i sporten från första hoppet räknat</li>
                            </ul>
                        </td>
                        <td>
                            <ul>
                                <li>hoppa på landningsområde med storlek hoppfält (50 m x 50 m) </li>
                                <li>deltaga i alla nationella och internationella tävlingar </li>
                                <li>hoppa uppvisning på fält av storlek hoppfält</li>
                                <li>utföra ballonghopp</li>
                                <li>utföra frifallsfotografering</li>
                                <li>hoppa tillsammans med tandemekipage efter tandeminstruktörs medgivande
                                </li>
                                <li>utföra FS-hopp i mörker</li>
                                <li>utföra höghöjdshopp </li>
                                <li>utföra hopp med vingoverall</li>
                                <li>använda integralhjälm med fast visir</li>
                                <li>genomgå HM- och KL-utbildning efter CI:s godkännande</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <th>D</th>
                        <td>
                            <ul>
                                <li>400 manuella hopp, varav 100 FS-hopp varav 25 FS-hopp med minst 3
                                    personer
                                </li>
                                <li>3 tim ackumulerad frifallstid</li>
                                <li>2 år i sporten från första hoppet räknat</li>
                            </ul>
                        </td>
                        <td>
                            <ul>
                                <li>genomgå T- och AFF-utbildning efter CI:s godkännande</li>
                                <li>genomgå surfkurs </li>
                                <li>utföra hopp utan sko</li>
                            </ul>
                        </td>
                    </tr>
                </tbody>
            </table>
        </Section>

        <Section id="hoppmastarhopp" name="Hoppmästarhopp">
            <SectionHeader>Hoppmästarhopp</SectionHeader>
            <p>Hoppmästarhopp får sitt namn från att de utförs tillsammans med en instruktör med som lägst
                behörigheten hoppmästare.</p>
            <p> Det är en progression utav fyra hopp där man övar på att match fallhastighet. Flyga fram
                till någon och ta tag på ett säkert sätt. På alla hopp hoppar mat ut ogreppat och det är
                elevens uppgift att ta sig till hoppmästaren. Svårighetsgraden ökas mellan varje hopp genom
                att instruktören är mindre hjälpsamma och ligger mer och mer stilla. De första hoppen
                hjälper instruktören till att matcha fallhastighet.</p>
            <p>Centralt för hopning tillsammans med andra är begreppet level, slott, dock</p>
            <dl>
                <dt>Level</dt>
                <dd>Var på samma höjd som den du ska docka med i samma fallhastighet.</dd>
                <dt>Slott</dt>
                <dd>Flyg fram till den plats du ska vara när du tar tag.</dd>
                <dt>Dock</dt>
                <dd>Ta tag i personen.</dd>
            </dl>
            <h3>Bryt</h3>
            <Image image={bryt} imageSmall={bryt_small} alt="Bryt" />

            <p>I slutet av hopp tillsammans med andra behöver man separera för att kunna dra sina
                fallskärmar
                utan kollisionsrisk. För att uppnå det vänder alla ut från centrum av formationen på en
                förutbestämd höjd. Trackar åt var sitt håll ner till sin drag höjd och drar där sina
                fallskärmar. Man pratar om brythöjd och draghöjd. Normalt för lite mer erfarna hoppare är
                brythöjden 1500m och draghöjden 1000m</p>
        </Section>
    </Article >
);

export default ALicens;